import { render, staticRenderFns } from "./HIcon2.vue?vue&type=template&id=4bddf901&"
import script from "./HIcon2.vue?vue&type=script&lang=js&"
export * from "./HIcon2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bddf901')) {
      api.createRecord('4bddf901', component.options)
    } else {
      api.reload('4bddf901', component.options)
    }
    module.hot.accept("./HIcon2.vue?vue&type=template&id=4bddf901&", function () {
      api.rerender('4bddf901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HIcon2.vue"
export default component.exports